import { useSearchParams } from 'react-router-dom'

const useParams = () => {
    const [searchParams, setSearchParams] = useSearchParams()

    const add = (key, value) => {
        searchParams.set(key, value)
        setSearchParams(searchParams)
    }

    const remove = (key) => {
        searchParams.delete(key)
        setSearchParams(searchParams)
    }

    const useQuery = () => {
        return new URLSearchParams(searchParams)
    }

    const urlParamiters = () => {
        return {
            id: useQuery().get('id')
        }
    }

    return { add, remove, useQuery, urlParamiters }
}
export { useParams }
